export enum FilterType {
  NORMAL = 'normal',
  CASH_REGISTER_FILTERS = 'cashRegisterFilters',
}
